module.exports = __webpack_public_path__ + "static/media/website-collage-mobile.00cb01b8.jpg";